import React from 'react'
import styled from '@emotion/styled'
import { ReactTypeformEmbed } from 'react-typeform-embed'

import Button from 'components/shared/Button'
import { breakpoints } from 'utils/styles'

class TypeFormPopup extends React.Component {
  constructor(props) {
    super(props);
    this.openForm = this.openForm.bind(this);
  }

  openForm() {
    this.typeformEmbed.typeform.open();
  }

  render() {
  	return (
      <div>
  		<ReactTypeformEmbed 
  			popup
        autoOpen={false}
  			hideHeaders
      	hideFooter
      	ref={tf => {
            this.typeformEmbed = tf;
        }}
        style={{ left: `-100%` }}
  			url="https://chrishoyle.typeform.com/to/ptIiS9"/>
			<Button onClick={this.openForm}>Start Survey</Button>
		</div>
  	)
  }
}

const Banner = styled.div`
	background-color: rgb(225, 240, 250);
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px inset;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  border-radius: 0px;
  border-left: 3px solid transparent;
  padding: 25px 0px;
  @media (max-width: ${breakpoints.tablet}px) { 
    padding: 15px 40px;
  }
`

const Text = styled.div`
  margin-right: 50px;
  h2 {
    margin-bottom: 8px;
    font-size: 1.1rem;
    color: rgb(0,0,0,.7)
  }
  p {
    margin-bottom: 0;
    font-size: .97rem;
    color: rgb(0,0,0,.4)
  }
  @media (max-width: ${breakpoints.tablet}px) {
    margin-right: 0px;
    margin-bottom: 30px;
  }

`
const Inner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  text-align: center;
  @media (min-width: ${breakpoints.tablet}px) {
    text-align: left;
    width: 72rem;
    flex-direction: row;
  }
`

export default () => (
	<Banner>
    <Inner>
      <Text>
    		<h2>Complete Data Privacy Survey</h2>
        <p>Let us know your opinons around using data for public good. It will take two minutes.</p>
  		</Text>
      <TypeFormPopup/>
    </Inner>
	</Banner>
)





